import {calculateTripDuration} from "@Route/functions/calculateTripDuration";
import RouteType from "@Route/types/Route.type";
import getMinimalPrice from "@Tabs/functions/getMinimalPrice";
import IntermodalRouteType from "@Intermodal/types/IntermodalRoute.type";

/**
 * Generates tab based on type passed
 */

interface GenerateTabAttributes {
    routes: RouteType[],
    intermodalRoutes?: IntermodalRouteType[],
    type: string,
}

export default function generateTab({routes, type, intermodalRoutes}: GenerateTabAttributes) {
    const {travelInfo: {departureStation, destinationStation}} = routes[0];
    const activeRoutes = routes.filter((route) => route.status.status === 'open' && routes)
    const availableRoutes = routes.filter((route) => route.status.status !== 'unavailable' && routes)
    const minPrice = getMinimalPrice(activeRoutes)
    const redirectRoutes = routes.filter((route) => route.status.isApi && route.status.hasRedirectLink && routes)
    const duration = calculateTripDuration(
        `${departureStation.departureDate} ${departureStation.departureTime}`,
        `${destinationStation.arrivalDate} ${destinationStation.arrivalTime}`
    )

    return {
        tabType: type,
        routes: routes.length + (intermodalRoutes?.length ?? 0),
        availableRoutes: availableRoutes.length,
        hasNonRedirectRoutes: !!(routes.length - redirectRoutes.length),
        minPrice,
        fastestRoute: duration,
    }
}